import React, { useState } from 'react';
import './App.css';
import { Link } from 'react-router-dom';

const badges = [
  { key: 'ritual', label: 'Practice Master', icon: '🕉️' },
  { key: 'streak', label: '7-Day Streak', icon: '🔥' },
  { key: 'journal', label: 'Journalist', icon: '📓' },
];

function Calendar() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDay = firstDay.getDay();
    
    const days = [];
    for (let i = 0; i < startingDay; i++) {
      days.push(null);
    }
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(new Date(year, month, i));
    }
    return days;
  };

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const prevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const nextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  const days = getDaysInMonth(currentDate);
  const isToday = (date) => {
    const today = new Date();
    return date && date.toDateString() === today.toDateString();
  };
  const isSelected = (date) => {
    return date && date.toDateString() === selectedDate.toDateString();
  };

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button onClick={prevMonth} className="calendar-nav-btn">‹</button>
        <h3>{monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}</h3>
        <button onClick={nextMonth} className="calendar-nav-btn">›</button>
      </div>
      <div className="calendar-grid">
        <div className="calendar-day-header">Sun</div>
        <div className="calendar-day-header">Mon</div>
        <div className="calendar-day-header">Tue</div>
        <div className="calendar-day-header">Wed</div>
        <div className="calendar-day-header">Thu</div>
        <div className="calendar-day-header">Fri</div>
        <div className="calendar-day-header">Sat</div>
        {days.map((day, index) => (
          <div
            key={index}
            className={`calendar-day ${!day ? 'empty' : ''} ${isToday(day) ? 'today' : ''} ${isSelected(day) ? 'selected' : ''}`}
            onClick={() => day && setSelectedDate(day)}
          >
            {day ? day.getDate() : ''}
          </div>
        ))}
      </div>
      <div className="calendar-info">
        <p>Selected: {selectedDate.toDateString()}</p>
      </div>
    </div>
  );
}

function Planner() {
  const [habits, setHabits] = useState([
    { name: 'Morning Meditation', done: false, streak: 0, total: 0 },
    { name: 'Gratitude Journal', done: false, streak: 0, total: 0 },
    { name: 'Evening Practice', done: false, streak: 0, total: 0 },
  ]);
  const [newHabit, setNewHabit] = useState('');
  const [journal, setJournal] = useState('');
  const [journalSaved, setJournalSaved] = useState(false);

  // Helper to check if mobile view
  const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 480px)').matches;

  const toggleHabit = idx => {
    setHabits(habits.map((h, i) => {
      if (i === idx) {
        const newDone = !h.done;
        return {
          ...h,
          done: newDone,
          streak: newDone ? h.streak + 1 : h.streak,
          total: newDone ? h.total + 1 : h.total
        };
      }
      return h;
    }));
  };

  const addHabit = (e) => {
    e.preventDefault();
    if (newHabit.trim()) {
      setHabits([...habits, { name: newHabit.trim(), done: false, streak: 0, total: 0 }]);
      setNewHabit('');
    }
  };

  const removeHabit = (idx) => {
    setHabits(habits.filter((_, i) => i !== idx));
  };

  const handleJournalChange = e => setJournal(e.target.value);
  const handleJournalSave = e => {
    e.preventDefault();
    setJournalSaved(true);
    setTimeout(() => setJournalSaved(false), 2000);
  };

  return (
    <div className="main-bg">
      {/* Hide hero-section on mobile */}
      {!isMobile && (
        <header className="hero-section">
          <h1 className="site-title">Self-Scheduler & Spiritual Planner</h1>
          <p className="site-tagline">Stay on track with practices, sync your calendar, track habits, earn badges, and journal your journey.</p>
        </header>
      )}
      <div className="planner-section">
        <div className="planner-row">
          <div className="planner-card">
            <h3>Calendar View</h3>
            <Calendar />
          </div>
          <div className="planner-card">
            <h3>Earn Spiritual Badges</h3>
            <div className="planner-badges">
              {badges.map(b => (
                <span className="planner-badge" key={b.key} title={b.label}>{b.icon} <span className="badge-label">{b.label}</span></span>
              ))}
            </div>
          </div>
        </div>
        <div className="planner-row">
          <div className="planner-card" style={{ width: '100%' }}>
            <h3>Habit & Practice Tracker</h3>
            <form onSubmit={addHabit} className="habit-form">
              <input
                type="text"
                value={newHabit}
                onChange={(e) => setNewHabit(e.target.value)}
                placeholder="Add a new habit..."
                className="habit-input"
              />
              <button type="submit" className="planner-btn">Add Habit</button>
            </form>
            <div className="habits-container">
              {habits.map((h, i) => (
                <div key={h.name} className={`habit-item ${h.done ? 'done' : ''}`}>
                  <div className="habit-info">
                    <div className="habit-header">
                      <input
                        type="checkbox"
                        checked={h.done}
                        onChange={() => toggleHabit(i)}
                        className="habit-checkbox"
                      />
                      <span className="habit-name">{h.name}</span>
                      <button
                        onClick={() => removeHabit(i)}
                        className="habit-remove"
                        title="Remove habit"
                      >
                        ×
                      </button>
                    </div>
                    <div className="habit-stats">
                      <span className="streak">🔥 {h.streak} day streak</span>
                      <span className="total">📊 {h.total} total</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="planner-row">
          <div className="planner-card" style={{ width: '100%' }}>
            <h3>Journal Integration</h3>
            <form className="planner-journal" onSubmit={handleJournalSave}>
              <textarea value={journal} onChange={handleJournalChange} placeholder="Write your thoughts, dreams, or insights..." rows={3} required />
              <button className="planner-btn" type="submit">Save Journal Entry</button>
              {journalSaved && <div className="custom-success">Journal entry saved!</div>}
            </form>
          </div>
        </div>
      </div>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Planner; 